import React from "react"
import classNames from "classnames"
import Icon from "../Icon/Icon"

export interface AiInsightsPendingProps {
	message?: string
}

export function AiInsightsError({message = "An error has occurred"}: AiInsightsPendingProps) {
	return (
		<span className={classNames("ai-insights-pending")}>
			<span className="ai-insights-pending-icon">
				<Icon icon="delete-close-x-circle" size={16} />
			</span>
			<span className="ai-insights-pending-label">{message}</span>
		</span>
	)
}
